module.exports = __webpack_public_path__ + "img/loading-infinite.9e51aad0.svg";